"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiProvider = void 0;
class ApiProvider {
    constructor(variables) {
        this._apiUrls = {};
        if (variables === null || variables === void 0 ? void 0 : variables.apiUrls) {
            this.setApiUrls(variables.apiUrls);
        }
    }
    // Change default apollo client url
    selectAPI(apiUrl) {
        this._api = this.getApiUrl(apiUrl);
        return this;
    }
    getApiUrl(API) {
        const apiUrl = this._apiUrls[API];
        if (!apiUrl) {
            console.log(`url: ${API} not found. Did you set it with setApiUrls function inside base service?`);
            return '';
        }
        return apiUrl;
    }
    setApiUrls(urls) {
        this._apiUrls = urls;
    }
}
exports.ApiProvider = ApiProvider;
//# sourceMappingURL=ApiProvider.js.map